import CloseIcon from '@mui/icons-material/Close'
import {
  FC,
  ReactChild,
  ReactChildren,
  ReactNode,
  useEffect,
  useState,
} from 'react'
import {
  Header,
  ContentWrapper,
  StyledSwiper,
  IconWrapper,
  Wrapper,
} from './Drawer.styles'
import { Typography, Box } from '@mui/material'

interface SwipeableDrawerCustomProps {
  onClose?: () => void
  onOpen?: () => void
  open: boolean
  anchor?: 'left' | 'right' | 'top' | 'bottom'
  title?: ReactNode
  RightComponent?: any
  swipeAreaWidth?: number
  className?: string
  children: ReactChildren | ReactChild | Element | ReactChild[] | Element[]
}

const Drawer: FC<SwipeableDrawerCustomProps> = ({
  children,
  open: show,
  onClose,
  onOpen,
  anchor = 'left',
  title,
  className,
  swipeAreaWidth,
  RightComponent,
  ...rest
}: SwipeableDrawerCustomProps) => {
  const [open, setOpen] = useState(show)

  useEffect(() => {
    setOpen(show)
  }, [show])

  const handleClose = () => {
    onClose?.()
    setOpen(false)
  }

  const handleOpen = () => {
    onOpen?.()
    setOpen(true)
  }
  return (
    <StyledSwiper
      open={open}
      anchor={anchor}
      onClose={handleClose}
      onOpen={handleOpen}
      swipeAreaWidth={swipeAreaWidth}
      {...rest}
    >
      <Wrapper className={className}>
        <Box className="container">
          <Header>
            {typeof title === 'string' ? (
              <Typography variant="h6">{title}</Typography>
            ) : (
              title
            )}
            {RightComponent ? (
              <RightComponent />
            ) : (
              <IconWrapper onClick={handleClose}>
                <CloseIcon className={`${className}-close`} />
              </IconWrapper>
            )}
          </Header>
          <ContentWrapper>{children}</ContentWrapper>
        </Box>
      </Wrapper>
    </StyledSwiper>
  )
}

export default Drawer
